import { PasswordInput } from "@mantine/core";

import { EButton, ETextInput } from "../../../../libs/ui";

import "./ForgotPassword.scss";

import useForgotPassword from "../../Hooks/useForgotPassword";


export default function ForgotPassword() {

    const {
        activeStep,
        params,
        handleParamsChange,
        requestOTP,
        resendOTP,
        verifyOTP,
        handleCancel,
        isLoading,
        isResending,
        canResend,
        resendTimer,
    } = useForgotPassword();

    return (
        <div className="page-forgot-password">
            <div className="background"></div>
            <div className="body">
                <div className="inner">
                    <div className="w-full flex items-center gap-3">
                        <img
                            width={60}
                            height={60}
                            className="rounded-md shadow-blue-300 shadow"
                            src={require("../../../../assets/image/PMLLogo.png")}
                            alt="PML_logo"
                        />
                        <p className="text-xl font-semibold">Reset Password</p>
                    </div>

                    <div className="w-full px-6 mt-10">
                        {activeStep === 1 ? (
                            <div className="flex flex-col gap-3">
                                <div>
                                    <h3 className="text-2xl font-semibold text-gray-800">Reset Password</h3>
                                    <p className="text-sm text-gray-600 mt-1">
                                        Please enter your email address to receive OTP
                                    </p>
                                </div>

                                <form
                                    className="reset-form"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        requestOTP();
                                    }}
                                >
                                    <ETextInput
                                        required
                                        size="md"
                                        variant="unstyled"
                                        placeholder="Enter Email"
                                        className="border-b px-2"
                                        value={params.email}
                                        onChange={(e) => {
                                            handleParamsChange("email", e.target.value);
                                        }}
                                    />

                                    <div className="flex gap-3 mt-5">
                                        <EButton
                                            fullWidth
                                            type="button"
                                            size="md"
                                            variant="light"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </EButton>
                                        <EButton
                                            fullWidth
                                            type="submit"
                                            size="md"
                                            loading={isLoading}
                                        >
                                            Request OTP
                                        </EButton>
                                    </div>
                                </form>
                            </div>
                        ) : (
                            <div className="flex flex-col gap-3">
                                <div>
                                    <h3 className="text-2xl font-semibold text-gray-800">Verify OTP</h3>
                                    <p className="text-sm text-gray-600 mt-1">
                                        Please enter the OTP sent to your email and set your new password
                                    </p>
                                </div>

                                <form
                                    className="verify-form"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        verifyOTP();
                                    }}
                                >
                                    <ETextInput
                                        required
                                        size="md"
                                        variant="unstyled"
                                        placeholder="Enter Email"
                                        className="border-b px-2"
                                        value={params.email}
                                        disabled
                                    />

                                    <div className="flex items-center gap-2 mt-3">
                                        <ETextInput
                                            required
                                            size="md"
                                            variant="unstyled"
                                            placeholder="Enter OTP"
                                            className="border-b px-2 flex-1"
                                            value={params.otp}
                                            onChange={(e) => {
                                                handleParamsChange("otp", e.target.value);
                                            }}
                                        />
                                        <EButton
                                            type="button"
                                            size="sm"
                                            variant="link"
                                            className="mt-3"
                                            loading={isResending}
                                            onClick={() => resendOTP()}
                                            disabled={!canResend}
                                        >
                                            {canResend ? "Resend OTP" : `Resend in ${resendTimer}s`}
                                        </EButton>
                                    </div>

                                    <PasswordInput
                                        required
                                        size="md"
                                        variant="unstyled"
                                        className="border-b px-2 mt-3"
                                        placeholder="Enter New Password"
                                        value={params.password}
                                        onChange={(e) => {
                                            handleParamsChange("password", e.target.value);
                                        }}
                                    />

                                    <PasswordInput
                                        required
                                        size="md"
                                        variant="unstyled"
                                        className="border-b px-2 mt-3"
                                        placeholder="Confirm New Password"
                                        value={params.confirmPassword}
                                        onChange={(e) => {
                                            handleParamsChange("confirmPassword", e.target.value);
                                        }}
                                    />

                                    <div className="flex gap-3 mt-5">
                                        <EButton
                                            fullWidth
                                            type="button"
                                            size="md"
                                            variant="light"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </EButton>
                                        <EButton
                                            fullWidth
                                            type="submit"
                                            size="md"
                                            loading={isLoading}
                                        >
                                            Reset Password
                                        </EButton>
                                    </div>
                                </form>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
} 